/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
function ariaValueFromSize(axis, blockValue, inlineValue) {
  const selectedValue = axis === "block" ? blockValue : inlineValue;
  return selectedValue != null ? `${selectedValue}` : void 0;
}
function toAriaBoolean(value) {
  return Boolean(value).toString();
}
export {
  ariaValueFromSize as a,
  toAriaBoolean as t
};
